import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from '@/components/layout/admin/MainLayout.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from '@/assets/js/config.js';
import axios from 'axios';
import store from '@/store';
import ValidationService from '@/services/ValidationService';
import HandlePaginateService from '@/services/HandlePaginateService';
import { canManagePayment as checkCanManagePayment } from '@/services/PaymentAccessService';

export default {
  name: 'paymentList',
  components: {
    MainLayout,
    Loading,
    CONFIG,
    flatPickr,
    AdvancedLaravelVuePaginate,
    Select2Multiple,
  },

  mixins: [ValidationService],

  data() {
    return {
      isFilterOpen: false,
      paymentData: {},
      campusId: store.state.user.campus_id,
      paymentMethodArr: null,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      searchData: {
        acaYear: this.$store.state.academicYear,
        class_id: null,
      },
      academicYearArr: [],
      currentYearId: '',
      isSearch: 0,
      payMethod: [],
      itemArr: [],
      classArr: null,
      periodArr: [],
      search_period_id: null,
      totalReceivedAmount: 0,
      totalRequestedAmount: 0,
      search_status: false,
      searchedData: null,
      isSearched: false,
      CONFIG,
      dueDateConfig: {
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: 'Y-m',
            altFormat: 'Y-m',
            theme: 'light',
          }),
        ],
      },
    };
  },

  computed: {
    paymentOptions() {
      return Object.entries(CONFIG.PARENT_PAYMENT_STATUS_TEXT).map(([id, text]) => ({
        id: Number(id),
        text,
      }));
    },
    paymentHistoryOptions() {
      return CONFIG.PAYMENT_STATUSES_OPTIONS.filter((opt) => [
        CONFIG.PAYMENT_STATUS.STATUS_APPROVED,
        CONFIG.PAYMENT_STATUS.STATUS_PARENT_ENROLL_REQUEST,
        CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST,
      ].includes(opt.id));
    },
  },

  methods: {
    getStatusClass(status) {
      switch (Number(status)) {
        case CONFIG.PARENT_PAYMENT_STATUS.NOT_PAID:
          return 'bg-light';
        case CONFIG.PARENT_PAYMENT_STATUS.PARTIAL_PAID:
          return 'bg-warning';
        case CONFIG.PARENT_PAYMENT_STATUS.FULLY_PAID:
          return 'bg-success';
        default:
          return 'bg-light';
      }
    },

    getPeriods() {
      this.isLoading = true;
      axios.get('period/periodList')
        .then((res) => {
          const defaultOption = [{ id: '0', text: 'Select Academic Year' }];
          const periods = res.data?.data || res.data || [];
          this.periodArr = defaultOption.concat(Array.isArray(periods) ? periods : []);

          this.isLoading = false;
        })
        .catch((error) => this.handleError(error));
    },

    getClass(yearId) {
      this.searchData.class_id = '';
      this.classArr = [];

      axios.get(`class/classList/${yearId}`, {
        params: {
          campus_id: this.$store.state.user.campus_id,
        },
      })
        .then((res) => {
          this.classArr = [{ id: '0', text: 'Select Class' }].concat(res.data);
          this.isLoading = false;
        }).catch((err) => this.handleError(err));
    },

    handleError(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
      this.isLoading = false;
    },

    getItem() {
      axios.get('item/getItemForPayment')
        .then((res) => {
          this.itemArr = res.data.data;
        }).catch((error) => {
          this.handleError(error);
        });
    },

    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id,
        },
      })
        .then((res) => {
          let $defaultSelectOption = [{
            id: 0,
            text: 'Select',
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
        }).catch((error) => {
          this.handleError(error);
        });
    },

    getPaymentMethod() {
      axios.get('getPaymentMethod')
        .then((res) => {
          let $defaultSelectOption = [{
            id: 0,
            text: 'Select Payment Method',
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data);
        }).catch((error) => {
          this.handleError(error);
        });
    },

    getPayment(page = 1) {
      page = this.normalizePage(page);
      this.search_status = false;
      axios.get(`payment/list?page=${page}`, {
        params: {
          campus_id: this.campusId,
        },
      })
        .then((res) => {
          if (res.data) {
            this.paymentData = res.data;
            const summary = this.paymentData.data || {};
            this.totalRequestedAmount = summary.totalRequestedAmount || 0;
            this.totalReceivedAmount = summary.totalReceivedAmount || 0;
            this.isLoading = false;
          }
        }).catch((error) => {
          this.handleError(error);
        });
    },

    confirmDelete(id) {
      if (window.confirm('Are you sure you want to delete?')) {
        this.delete(id);
      } else {
        console.log('no');
      }
    },

    delete(id) {
      this.isLoading = true;
      axios.post(`payment/delete/${id}/${store.state.user.campus_id}`)
        .then((res) => {
          this.isLoading = false;
          if (res.data) {
            this.getPayment();
            this.$notification.success('Payment Deleted Successfully', {
              timer: 3,
              position: 'bottomCenter',
            });
          }
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    normalizePage(page) {
      const pageNum = Number(page);
      return Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1;
    },

    searching(page = 1) {
      page = this.normalizePage(page);
      this.search_status = true;
      this.clearValidationErrors();
      this.isSearch = 1;
      this.isLoading = true;
      if (this.searchData.p_method == 0) {
        this.searchData.p_method = undefined;
      }

      const params = {
        stuName: this.searchData.stuName,
        item_id: this.searchData.item_id,
        p_method: this.searchData.p_method,
        startDate: this.searchData.startDate,
        endDate: this.searchData.endDate,
        invoiceNumber: this.searchData.invoiceNumber,
        status: this.searchData.status,
        history_status: this.searchData.history_status,
        dueDate: this.searchData.dueDate,
        campus_id: this.campusId,
        search: true,
        acaYear: this.search_period_id,
        classId: this.searchData.class_id,
      };

      this.searchedData = {
        ...params,
        is_search: 1,
        currentYear: this.currentYearId,
      };

      this.isSearched = true;

      axios.get('payment/search?page=' + page, { params })
        .then((res) => {
          console.log("API Response from server:", res.data);
          if (res.data) {
            this.paymentData = res.data;
            const summary = this.paymentData.data || {};
            this.totalRequestedAmount = summary.totalRequestedAmount || 0;
            this.totalReceivedAmount = summary.totalReceivedAmount || 0;
          }
        })
        .catch(error => {
          this.printValidationError(error.response);
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    reset() {
      this.search_period_id = '0';
      this.termArr = [];
      this.classArr = [];
      this.searchData = [];
      this.classArr = [];
      this.isLoading = true;
      this.getPayment();
      this.isSearched = false;
    },

    getThisAcademicYear() {
      this.isLoading = true;
      axios.get('period/getThisPeriod')
        .then((res) => {
          this.currentYearId = res.data.id;
          this.isLoading = false;
        }).catch((error) => {
          this.handleError(error);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {
          campus_id: this.campusId,
          currentYear: this.currentYearId,
          is_search: this.isSearch,
        };
      axios.get('/payment/excelDownload', {
        params,
        responseType: 'arraybuffer',
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          let date = new Date();
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `payment_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch((error) => {
          this.handleError(error);
        });
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page: this.normalizePage(page),
        isSearch: this.search_status,
        searchFn: this.searching,
        listFn: this.getPayment,
      });
    },

    filterReceivedAmount(field) {
      let value = this.searchData[field];

      value = value.replace(/[^0-9]/g, '');
      value = value.replace(/^0+/, '');

      this.searchData[field] = value ? parseInt(value) : null;
    },

    showDetail(studentPaymentId) {
      this.$router.push({
        name: 'paymentDetail',
        params: { invoiceId: studentPaymentId },
      });
    },

     showEdit(studentPaymentId) {
      this.$router.push({
        name: 'paymentEdit',
        params: { invoiceId: studentPaymentId }
      });
    },

    /**
     * Common payment action permission checker (includes fully paid + role restriction logic)
     * @param {string} action - edit/delete
     * @param {number} historyStatus - payment_history_status from payment table
     * @returns {boolean}
     */
    canManagePayment(action, historyStatus) {
      return checkCanManagePayment(action, historyStatus, this.$store.state.user);
    },

    getPaymentStatusText(payment) {
      if (payment.payment_history_status_text) {
        return payment.payment_history_status_text;
      }

      return CONFIG.PARENT_PAYMENT_STATUS_TEXT[payment.payment_history_status] || '-';
    },

    calculateRemainAmt(total, paid) {
      if (total == null) {
        return '0 MMK';
      }

      const parseAmount = (val) => {
        if (val == null || val === '') {
          return 0;
        }
        const numeric = String(val).replace(/,/g, '').split(' ')[0];
        const parsed = parseFloat(numeric);
        return Number.isFinite(parsed) ? parsed : 0;
      };

      const totalNum = parseAmount(total);
      const paidNum = parseAmount(paid);
      const parts = String(total).trim().split(' ');
      const currency = parts.length > 1 ? parts.slice(1).join(' ') : 'MMK';
      const remain = Math.max(totalNum - paidNum, 0);

      return `${remain.toLocaleString('en-US')} ${currency}`;
    },

    formatAcademicYear(payment) {
      return payment.period_name || payment.class_name || '-';
    },

    /**
     * Check if edit button should be shown for a payment
     * @param {object} payment - payment object
     * @returns {boolean}
     */
    canEditPayment(payment) {
      return this.canManagePayment('edit', payment.payment_history_status);
    },
  },

  mounted() {
    this.isLoading = true;
    this.isSearch = 0;
    this.getPeriods();
    this.getThisAcademicYear();
    this.getPaymentMethod();
    this.getItem();
    this.getPayment();
  },
};
